// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"305c0ae4","514":"6394aaef","520":"7182dfd7","722":"4a77c5f0","795":"06163dab","844":"98a47fd1"}[chunkId] + ".chunk.js";
};